import React from 'react';
import { useSelector } from 'react-redux';
import Header from './Header';
import PageContainer from './PageContainer';
import { modal, editFormDialog } from './modal/ModalEmitter';
import AuthService from '../services/AuthService';

const pages = ['PTB1', 'STB1', 'ATY1', 'ATY2', 'ATY3', 'ATY4', 'ATY5', 'ATY6', 'ATY7', 'LAU9'];

const InitialsSetup = () => {
  const { searchData } = useSelector(state => state.app);

  const launch = pageName => {
    modal.open('editItem', {
      ...editFormDialog,
      itemName: pageName,
      render: 'editItem',
      title: searchData[pageName].title,
    });
  };

  return (
    <PageContainer>
      <Header hasDocs={false} pageName="UST3L" showInfo={false} title="Initials Setup" />
      <div style={{ padding: '15px' }}>
        {pages.map(page => {
          if (AuthService.hasPermission(page)) {
            return (
              <div className="basic-menu-item" onClick={() => launch(page)}>
                {searchData[page].title}
              </div>
            );
          }
        })}
      </div>
    </PageContainer>
  );
};

export default InitialsSetup;
